Ext.define('SA.model.UnaryCondition', {
    constructor({attributeId, operator, operand}) {
        this.attributeId = attributeId;
        this.operator = operator;
        this.operand = operand;
    },

    getAttributeId() {
        return this.attributeId;
    },

    getOperand() {
        return this.operand;
    },

    getOperator() {
        return this.operator;
    },

    isBetweenCondition() {
        return false;
    },

    toPredicate() {
        return SA.Predicate.create([this.getOperator(), this.getAttributeId(), this.getOperand()]);
    }
});